import { NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { QpxBody, QpxModalTitle, QpxIcon } from '../../directives';
import type {
    DataStateImage,
    DataStateLayout,
    DataStateVisualSize,
} from './models';

type IconOptions = {
    name: string;
};
type IconInput = string | Partial<IconOptions>;
type EmptyStateHeadingLevel = 2 | 3;
const defaultIcon: IconOptions = {
    name: 'lucideSearchX',
};

@Component({
    selector: 'qpx-empty-state',
    imports: [NgIcon, QpxIcon, QpxModalTitle, QpxBody, NgOptimizedImage],
    templateUrl: './empty-state.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'qpx-empty-state',
        '[class.inline]': 'layout() === "inline"',
        '[class.stacked]': 'layout() === "stacked"',
        '[class.hero]': 'visualSize() === "hero"',
        '[class.icon]': 'visualSize() === "icon"',
    },
})
export class EmptyState {
    //#region Inputs
    public readonly heading = input('No items found');
    public readonly headingLevel = input<EmptyStateHeadingLevel>(3);
    public readonly image = input<DataStateImage | null>(null);
    public readonly layout = input<DataStateLayout>('stacked');
    public readonly visualSize = input<DataStateVisualSize>('icon');
    public readonly icon = input<IconOptions, IconInput>(defaultIcon, {
        transform: (value) => {
            if (typeof value === 'string') {
                return { ...defaultIcon, name: value };
            }
            return { ...defaultIcon, ...value };
        },
    });
    //#endregion

    //#region State
    protected readonly iconName = computed(() => this.icon().name);
    //#endregion
}
